import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './utility/auth/msalConfig'

const msalInstance = new PublicClientApplication(msalConfig)

const bootstrap = async () => {
  await msalInstance.initialize()
  // handleRedirectPromise processes the auth code when Entra redirects back
  // Returns null on normal page loads (no redirect pending)
  const result = await msalInstance.handleRedirectPromise()
  if (result) {
    // Store idToken so the app can pick it up and complete login
    sessionStorage.setItem('msal_sso_result', JSON.stringify({
      idToken: result.idToken,
      email:   result.account?.username,
    }))
  }
  // await enableMocking()
  ReactDOM.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root')
  )
}

bootstrap().catch(console.error)